export default "__VITE_ASSET__DzLL6J_6__"